var e={exports:{}};export{e as __module};
//# sourceMappingURL=index5.js.map
